import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_fuego-detailing/artifacts/wa4uah1j_small%20verison%20logo.png";

export const Logo = ({ size = "md", showText = false }) => {
  const dims = { sm: "h-10", md: "h-12", lg: "h-20", xl: "h-32 md:h-40" }[size] || "h-12";
  return (
    <div className="flex items-center" data-testid="brand-logo">
      <img
        src={LOGO_URL}
        alt="Fuego Precision Detailing"
        className={`${dims} w-auto object-contain`}
        draggable={false}
      />
    </div>
  );
};
